module.exports = __webpack_public_path__ + "img/10.f89c56ee.png";